var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.containerClass},[_c('p',[_c('strong',[_vm._v(_vm._s(_vm.label))])]),_vm._v(" "),_c('ul',{staticClass:"list-group"},_vm._l((_vm.LANGUAGES),function(lang){return _c('li',{staticClass:"list-group-item"},[_c('b',[_vm._v(_vm._s(lang)+":")]),_vm._v("\n\t\t\t"+_vm._s(_vm.value[lang])+"\n\t\t")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }